const versionPattern = /^\d+\.\d+\.\d+$/;

export function isValidAppVersion(version: unknown): version is string {
  return typeof version === 'string' && versionPattern.test(version.trim());
}

/**
 * Numeric major.minor.patch comparison.
 * Returns -1 when a < b, 0 when equal, 1 when a > b.
 */
export function compareAppVersions(a: string, b: string): number {
  const partsA = a.trim().split('.').map(Number);
  const partsB = b.trim().split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    const numA = partsA[i] ?? 0;
    const numB = partsB[i] ?? 0;
    if (numA < numB) return -1;
    if (numA > numB) return 1;
  }
  return 0;
}
